import axios from '@/lib/axios';
import { LensOrderParams } from '../types';

const confirmCommercialLens = (data: LensOrderParams) => {
  return axios.post('/facility/orders/commercial_lens/confirm', data);
}

export default confirmCommercialLens;